import { EChatActionTypes } from 'shared/actions/chat';
import { IAppState, TActions } from 'shared/common/state';
import { getChatOnboarding } from 'shared/utils/chatOnboarding';

export function chatOnboardingReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'filters/search/SEARCH_REQUEST_FINISHED':
      return {
        ...state,
        chatOnboarding: getChatOnboarding({
          config: state.config,
          data: action.data,
        }),
      };

    case EChatActionTypes.Open:
    case EChatActionTypes.OpenAfterAuth:
      if (state.chatOnboarding.offerChatOnboarding && action.payload.offer.newbuilding?.isFromBuilder) {
        return {
          ...state,
          chatOnboarding: {
            ...state.chatOnboarding,
            offerChatOnboarding: {
              ...state.chatOnboarding.offerChatOnboarding,
              wasChatOpened: true,
            },
          },
        };
      }

      return state;
    default:
      return state;
  }
}
